export enum TristateBoolean {
    TRUE = 'TRUE',
    FALSE = 'FALSE',
    INDETERMINATE = 'INDETERMINATE',
}
